import ar_white from "../../../assets/images/Introduction/ar_white.svg";
import home_white from "../../../assets/images/Introduction/home_white.svg";
import news_mobi from "../../../assets/images/NewEvent/news_mobi.webp";
import news_pc from "../../../assets/images/NewEvent/news_pc.webp";

export default function NewEventBanner() {
  return (
    <div className="w-full">
      <div className="w-full">
        <div
          className="block md:hidden lg:hidden w-full relative bg-center bg-cover bg-no-repeat"
          style={{
            backgroundImage: `url(${news_mobi})`,
          }}
        >
          <div className="w-full ">
            <div className="w-full mx-auto flex flex-col gap-2 items-center justify-center pt-16 py-[20px] px-[20px]">
              <div className="w-full rounded-[40px] flex gap-1">
                <div className="flex items-center gap-2">
                  <img src={home_white} alt="home1" />
                  <img src={ar_white} alt="ar" />
                </div>
                <div>
                  <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                    Tin tức
                  </p>
                </div>
              </div>
              <div className="w-full">
                <p className="text-[32px] font-semibold text-white">
                  TIN TỨC & SỰ KIỆN
                </p>
                <p className="text-white text-[16px] font-normal">
                  Cập nhật những xu hướng công nghệ giáo dục mới nhất và những
                  hoạt động nổi bật từ BlueRise
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="hidden md:block lg:block w-full relative h-[20rem] mt-1 bg-cover bg-no-repeat bg-center"
          style={{
            backgroundImage: `url(${news_pc})`,
          }}
        >
          <div className="w-full mx-auto h-[20rem] ">
            <div className=" flex flex-col gap-2 items-center justify-center w-full mx-auto pt-20">
              <div className="w-full h-[2.625rem] rounded-[40px] flex items-center justify-center ">
                <div className="flex items-center gap-2">
                  <img src={home_white} alt="home1" />
                  <img src={ar_white} alt="ar" />
                </div>
                <div>
                  <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                    Tin tức
                  </p>
                </div>
              </div>
              <div className="w-full text-center">
                <p className="text-[32px] font-semibold text-white">
                  TIN TỨC & SỰ KIỆN
                </p>
                <p className="text-white text-[18px] font-normal">
                  Cập nhật những xu hướng công nghệ giáo dục mới nhất và những
                  hoạt động nổi bật từ BlueRise
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
